import api from "./axios";

const toMinorUnit = (amount, currency) => {
  if (!amount) return 0;

  switch (currency) {
    case "ILS":
    case "USD":
    case "EUR":
      return Math.round(Number(amount) * 100);
    default:
      return Number(amount);
  }
};

export const createPaymentIntent = async (amount, currency) => {
  const amountInMinorUnit = toMinorUnit(amount, currency);

  try {
    const response = await api.post(
      "/payments/create-payment-intent",
      {
        amount: amountInMinorUnit,
        currency
      },
      {
        timeout: 10000
      }
    );

    return response.data;
  } catch (err) {
    throw err;
  }
};
